import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Status } from '@df/core/status';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'icms-skeleton-loader',
    templateUrl: 'icms-skeleton-loader.html',
    styleUrls: ['./icms-skeleton-loader.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsSkeletonLoaderComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    numberOfLines: number = 3;

    @Input()
    numberOfColumns: number = 4;

    @Input()
    status?: Status;

    @Input()
    variant: 'default' | 'media' = 'default';

    protected lines: number[] = [];
    protected squares: number[] = [];
    private statusSubscription?: Subscription;

    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        switch (this.variant) {
            case 'default':
                this.lines = Array(this.numberOfLines).fill(0);
                break;
            case 'media':
                this.squares = Array(this.numberOfColumns * this.numberOfLines).fill(0);
                break;
        }
    }

    ngOnChanges(changes): void {
        if (changes.status) {
            this.statusSubscription?.unsubscribe;
            this.statusSubscription = this.status?.subscribe(() => this.changeDetectorRef.detectChanges());
        }
    }

    ngOnDestroy(): void {
        this.statusSubscription?.unsubscribe;
    }
}
